import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const OrderContext = createContext(null);

const STORAGE_KEY = "dzt_order";

const loadInitial = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) {
    console.error("Bestelling laden uit sessie mislukt:", e);
  }
  return { quantities: {}, packaging: "", pickupDate: "", pickupLabel: "", timeSlot: "", categoryPickups: {}, budget: "", cutlery: 0 };
};

export const OrderProvider = ({ children }) => {
  const [order, setOrder] = useState(loadInitial);
  const [config, setConfig] = useState(null);
  const [menu, setMenu] = useState([]);
  const [menuLoading, setMenuLoading] = useState(true);
  const [menuError, setMenuError] = useState(false);

  const refreshMenu = useCallback(() => {
    setMenuLoading(true);
    return axios
      .get(`${API}/menu`)
      .then((r) => {
        setMenu(Array.isArray(r.data) ? r.data : []);
        setMenuError(false);
      })
      .catch((e) => {
        console.error("Menu laden mislukt:", e);
        setMenuError(true);
      })
      .finally(() => setMenuLoading(false));
  }, []);

  useEffect(() => {
    axios.get(`${API}/config`).then((r) => setConfig(r.data)).catch((e) => console.error("Config laden mislukt:", e));
    refreshMenu();
  }, [refreshMenu]);

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(order));
  }, [order]);

  const update = useCallback((patch) => setOrder((prev) => ({ ...prev, ...patch })), []);

  const setQuantity = useCallback(
    (id, value) =>
      setOrder((prev) => ({
        ...prev,
        quantities: { ...prev.quantities, [id]: Math.max(0, value) },
      })),
    []
  );

  const value = useMemo(
    () => ({ order, update, setQuantity, config, menu, menuLoading, menuError, refreshMenu }),
    [order, update, setQuantity, config, menu, menuLoading, menuError, refreshMenu]
  );

  return <OrderContext.Provider value={value}>{children}</OrderContext.Provider>;
};

export const useOrder = () => useContext(OrderContext);
export { API };

